import React from 'react';
import classNames from 'classnames';
import QuantityPricingTools from './quantity-pricing-tools';
import Currency from '../_utils/tools/currency';
import { builderDispatch, PrismUI } from '../_utils/ui';

const isMobile = () =>
  typeof window !== 'undefined' && window.innerWidth < 768;

const Quantity = ({
  products,
  copies,
  showUnitPriceOnItemPages,
}) => {
  const getProduct = (products = []) => {
    if (products.length === 1) {
      return products[0];
    }
    if (products.length > 1) {
      return products.reduce((memo, p) =>
        p.minimum_price < memo.minimum_price ? p : memo
      );
    }
    return null;
  };
  const product = getProduct(products);

  const handleCopiesChanged = (value) => {
    builderDispatch.dispatch({
      type: PrismUI.EVENT_QUANTITY_CHANGED,
      value,
    });
  };

  const renderQuantityDropdown = () => (
    <div className="align-items-center quantity d-flex flex-row">
      <label
        className="col mr-2 quantity-label"
        id="quantity-and-price-label"
      >
        Quantity:
      </label>
      <div className="dropup">
        <button
          className="btn btn-link new-dropdown-toggle"
          role="combobox"
          data-toggle="dropdown"
          aria-label="quantity"
          aria-controls="quantity-list"
          aria-expanded={false}
        >
          {copies}
        </button>
        <div
          className="dropdown-menu dropdown-menu-right"
          id="quantity-list" 
          aria-labelledby="quantity-and-price-label"
        >
          {product &&
            new QuantityPricingTools(product)
              .generateOptions()
              .map(({ product: prodLabel, quantity, unitPrice, cost }) => {
                const active = copies === quantity;
                return (
                  <button
                    key={quantity}
                    className={classNames('btn btn-link dropdown-item', { active })}
                    onClick={() => handleCopiesChanged(quantity)}
                  >
                    <i
                      className={classNames('fas fa-check mr-2', {
                        invisible: !active,
                      })}
                    />
                    {quantity} {prodLabel}{showUnitPriceOnItemPages ? '\u00A0' : ` ${Currency.format(cost)}`}
                    <small>({Currency.format(unitPrice)} each)</small>
                  </button>
                );
              })}
        </div>
      </div>
    </div>
  );
  if (!product || !product.show_quantity_dropdown) return null;

  return (
    <div>
      <div className="row">
        <div
          className={classNames(
            { 'offset-6': isMobile() }
          )}
        >
          {renderQuantityDropdown()}
        </div>
      </div>
    </div>
  );
};

export default Quantity;
